import React from 'react';
import PropTypes, { any } from 'prop-types';

import { interpretStripeCardError } from '../../utils/payments';

const CheckoutFormStripeError = (props) => {
    const { error } = props;
    const message = interpretStripeCardError(error);
    return (
        <div className="invalid-feedback">{message}</div>
    );
};

CheckoutFormStripeError.propTypes = {
    error: PropTypes.objectOf(any).isRequired,
};

CheckoutFormStripeError.defaultProps = {

};

export default CheckoutFormStripeError;
